import {required} from 'vuelidate/lib/validators'
import {mapGetters, mapMutations} from 'vuex';

export default {
    props: ['popupType', 'selectedItem'],
    data() {
        return {
            form: {
                title: '',
                domain: '',
                api_key: '',
                price_ratio: '',
                callback_url: '',
                is_wholesale: '',
            },
        }
    },

    validations: {
        form: {
            title: {
                required
            },
            domain: {
                required
            },
            api_key: {
                required
            },
            price_ratio: {
                required
            },
            callback_url: {
                required
            },
        }
    },
    computed: {
        ...mapGetters({
            site: 'catalog/site',
        }),
    },
    watch: {
        site(e) {
            // console.log(e)
            if (e) {
                this.form.title = e.title;
                this.form.domain = e.domain;
                this.form.api_key = e.api_key;
                this.form.price_ratio = e.price_ratio;
                this.form.callback_url = e.callback_url;
                this.form.is_wholesale = Boolean(e.is_wholesale);
            }
        },
    },
    methods: {
        closePopup() {
            this.$emit('closePopup')
        },
        sendModel() {

            this.form.is_wholesale = Number(this.form.is_wholesale);
            if (this.site) {
                const payload = {
                    id: this.site.id,
                    data: this.form
                }
                this.$emit('changeSite', payload)
            } else {
                this.$emit('sendModel', this.form)
            }
        },
        // ...mapActions({
        //     getProductCategories: 'catalog/getProductCategories',
        //     getPriceCategories: 'catalog/getPriceCategories',
        //     getDepartments: 'catalog/getDepartments',
        //     getMaterials: 'catalog/getMaterials',
        //     getModels: 'catalog/getModels',
        //     getManufacturers: 'catalog/getManufacturers',
        //     storeProductImage: 'catalog/storeProductImage'
        // }),
        ...mapMutations({
            changeSite: 'catalog/changeSite'
        }),
    },
    destroyed() {
        this.changeSite(null);
    }
}
